import angular from 'angular'

angular.module('nominas.cargaservicios')
  .config(NominasCargaserviciosConfig);

function NominasCargaserviciosConfig($stateProvider) {
  $stateProvider.state('nominas.cargaServicios', {
    url: '/cargaServicios',
    data: {title: 'Carga de Servicios'},
    template: '<nominas-cargaservicios empresas="empresas" movimientos="movimientos"></nominas-cargaservicios>',
    controller: function ($scope, Catalogos) {
      $scope.empresas = Catalogos.Empresas;
      $scope.movimientos = Catalogos.Movimientos;
    },
    resolve: {
      Auth: ['Permisos', function (Permisos) {
        return Permisos.requerir('finances.cargaServicios');
      }],
      Catalogos: ['$catalogos', 'Auth', function ($catalogos) {
        return $catalogos.$fetch();
      }],
    },
  });
}




// WEBPACK FOOTER //
// ./src/nominas/cargaservicios/routes/nominas-cargaservicios.js